module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image13b.6039fa06.jpg";